/**
 * The consumer terms and the seller where a billing surface renders (TMMAPP-0119 §A,
 * TMMAPI-0156 U1): Settings' billing profile when it's loaded, else the bootstrap's. Both serve the
 * same values (MM-D-138); the profile is the fresher read on Settings.
 */
import { NO_CONSUMER_TERMS, type ConsumerTerms } from '@/api/consumerTerms';
import { getBootstrap } from '@/config/bootstrap';
import { useBillingProfile } from '@/features/settings/billingProfileContext';

/** The bootstrap's terms; the empty terms before it has resolved (never thrown). */
export function bootstrapConsumerTerms(): ConsumerTerms {
  try {
    return getBootstrap().consumerTerms;
  } catch {
    return NO_CONSUMER_TERMS;
  }
}

export function useConsumerTerms(): ConsumerTerms {
  const { profile } = useBillingProfile();
  const boot = bootstrapConsumerTerms();
  const served = profile?.consumerTerms;
  if (served === undefined) return boot;
  return {
    version: served.version ?? boot.version,
    termsUrl: served.termsUrl ?? boot.termsUrl,
    privacyUrl: served.privacyUrl ?? boot.privacyUrl,
    seller: served.seller ?? boot.seller,
  };
}
